import React from 'react';
import { Box, Skeleton } from '@mui/material';

function SkeletonChart({ count = 1 }) {
    return (
        <>
            {Array.from({ length: count }).map((_, index) => (
                <Box key={index} sx={{ width: '100%', maxWidth: '1000px', height: '300px', margin: '0 auto', mb: 4 }}>
                    <Skeleton variant="text" width="30%" height={40} sx={{ mx: 'auto', mb: 2 }} />
                    <Skeleton variant="rectangular" width="100%" height="100%" />
                </Box>
            ))}
        </>
    );
}

export default SkeletonChart;

